module.exports = __webpack_public_path__ + "static/media/stilly12.86a8a19b.JPG";